import http from "@/settings/apiSettings"

class CrmContactsDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PAR_Parteneri", data);
    }


    update(key: string, data: any): Promise<any> {
        return http.clientComercialOdata.patch(`/PAR_Parteneri(${key})`, data);
    }

    getById(key: string, expand = ''): Promise<any> {
        return http.clientComercialOdata.get(`/PAR_Parteneri(${key})?${expand}`);
    }
}
export default new CrmContactsDataService();